import {useEffect} from 'react';

// @ts-expect-error
import {ENGAGEMENT_FOUNDATION_MONTHLY} from 'shells/billing/consts';
import {PlanComparisonTableWrapper} from 'shells/billing/plan-comparison/plan-comparison-table-wrapper';
import {PlanPicker} from 'shells/billing/plans/plan-picker';

import type {GetAvailablePlans_recurlyAvailablePlans_inbox_plans as Plan} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../../../analytics-client';

import {useGetPlanComparisons} from '../../graphql/hooks';

import {SuiteHeader} from '../suite-header/suite-header';

type Props = {
    plans: Array<Plan>;
    errorMessage: string | null | undefined;
    isLoadingPlans: boolean;
    selectedPlanCode: string | null | undefined;
    setSelectedEngagementPlanCode: (planCode: string) => void;
    numUsers: string;
    setNumUsers: (numUsers: string) => void;
    numSalesUsers: string;
    numEnabledLicenses: number | null | undefined;
    scrollContainerId: string;
    isTrial: boolean;
};

export function EngagementSuitePicker(props: Props) {
    const {planComparisons} = useGetPlanComparisons('engagement');

    useEffect(() => {
        if (props.isTrial)
            analyticsClient.track(
                analyticsClient.EVENTS.TRACK_CUSTOMER_TRIAL_VISITS_BILLING_ENGAGEMENT
            );
    }, [props.isTrial]);

    return (
        <div className='pad-16 flex flex-dir-col full-width gap-8 border-box'>
            <SuiteHeader
                numUsers={props.numUsers || ''}
                onNumUsersChange={props.setNumUsers}
                numSalesUsers={props.numSalesUsers}
                numEnabledLicenses={props.numEnabledLicenses}
                hasUsersInput={props.selectedPlanCode !== ENGAGEMENT_FOUNDATION_MONTHLY}
                isMonthlyOnly={true}
                suite='engagement'
            />
            <PlanPicker
                variant='engagement'
                plans={props.plans}
                selectedPlanCode={props.selectedPlanCode}
                onSelectedPlanCodeChange={props.setSelectedEngagementPlanCode}
                isLoading={props.isLoadingPlans}
                errorMessage={props.errorMessage}
            />
            {!props.isLoadingPlans && planComparisons && (
                <PlanComparisonTableWrapper
                    planComparisons={planComparisons}
                    scrollContainerId={props.scrollContainerId}
                />
            )}
        </div>
    );
}
